import { configureStore } from '@reduxjs/toolkit'
import { persistStore } from 'redux-persist'
import { customMiddleware } from '@/store/middleware'
import { persistedReducer } from '@/store/rootReducer'

export const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.DEV,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }).concat(customMiddleware),
})

export const persistor = persistStore(store)
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
